var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2466_76315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C5.383 0.5 0 5.883 0 12.5C0 19.117 5.383 24.5 12 24.5C18.617 24.5 24 19.117 24 12.5C24 5.883 18.617 0.5 12 0.5ZM17.25 13.5H13V17.75C13 18.302 12.552 18.75 12 18.75C11.448 18.75 11 18.302 11 17.75V13.5H6.75C6.198 13.5 5.75 13.052 5.75 12.5C5.75 11.948 6.198 11.5 6.75 11.5H11V7.25C11 6.698 11.448 6.25 12 6.25C12.552 6.25 13 6.698 13 7.25V11.5H17.25C17.802 11.5 18.25 11.948 18.25 12.5C18.25 13.052 17.802 13.5 17.25 13.5Z",
    fill: "#ee9d12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5.5,
    width: 2,
    height: 14,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13.5,
    width: 2,
    height: 14,
    rx: 1,
    transform: "rotate(-90 5 13.5)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2466_76315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/PlusCircle.d62177702acad987e3954b1646b05198.svg";
export { ForwardRef as ReactComponent };